import React, {Fragment, useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import Container from "@material-ui/core/Container";
import CircularProgress from "@material-ui/core/CircularProgress";
import Box from "@material-ui/core/Box";
import {Animated} from "react-animated-css";
import PageHeaderAtm from "../../../../../atomic/PageHeader/PageHeader";
import {PageTitle} from "../../../../../atomic/PageHeader/PageTitle";
import {WEB, WEB_EDIT_SHORT} from "../../../../../../constants/appUrls.constants";
import {getFaqList} from "../../../../../../redux/actions/Web/Faq/faqActions";
import {getLanguages} from "../../../../../../redux/actions/languageActions";
import {isDefined} from "../../../../../../utils";
import faqStyles from "./faqStyles";
import useWebId from "./useWebId";
import FaqList from "./FaqList";

export default function FaqIndex() {
    const {t} = useTranslation();
    const classes = faqStyles();
    const dispatch = useDispatch();

    const {propertyWebId, fetching: webIdFetching} = useWebId();

    const fetching = useSelector(state => state.faqReducers?.fetching);
    const listData = useSelector(state => state.faqReducers?.listData);

    useEffect(() => {
        dispatch(getLanguages());
    }, [dispatch]);

    useEffect(() => {
        if (isDefined(propertyWebId)) {
            dispatch(getFaqList({property_web_id: propertyWebId}));
        }
    }, [dispatch, propertyWebId]);

    return (
        <Fragment>
            <PageTitle title={t('enw-web-faq-title', 'Sıkça Sorulan Sorular')}/>
            <PageHeaderAtm
                exitText={t('enw-web-edit-page_title')}
                backButton={!isDefined(propertyWebId) ? WEB : WEB_EDIT_SHORT + propertyWebId}
                text={t('enw-web-faq-title', 'Sıkça Sorulan Sorular')}
            />
            <Animated animationIn="fadeIn" animationInDuration={600} isVisible={true}>
                <Container maxWidth="xl">
                    <div className="container-width pb-0 mb-24">
                        {
                            (webIdFetching || fetching) ?
                                <Box className={classes.loadingBox}>
                                    <CircularProgress className={classes.spinner} style={{color: '#d71f26'}}/>
                                </Box>
                                :
                                <FaqList
                                    list={Array.isArray(listData) ? listData : []}
                                    propertyWebId={propertyWebId}
                                />
                        }
                    </div>
                </Container>
            </Animated>
        </Fragment>
    );
}
